var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1SocketOutdoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 69h62V7H7v62zm4-31V11h54v54H11V38zm51 0a24 24 0 10-48 0 24 24 0 0048 0zm-44 0a20 20 0 1140 0 20 20 0 01-40 0zm27.62.18a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM43 26.83a5 5 0 10-10 0 5 5 0 0010 0zm-7 0a2 2 0 114 0 2 2 0 01-4 0zm-5.62 11.35a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket_Outdoor.a4aac4cc.svg";
export { SvgA1SocketOutdoor as ReactComponent };